import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { RfpClientOneQuestionViewSkeleton } from '@/components/pages/rfp/client/RfpClientOneQuestionView/RfpClientOneQuestionViewSkeleton';
import { useRfpClient } from '@/hooks/pages/rfp/useRfpClient';
import { RfpClientOneQuestionPage } from '@/pages/rfp/client/RfpClientOneQuestion/RfpClientOneQuestionPage';
import { myPagePath } from '@/utils/router/links';
export const RfpClientOneQuestion = (props) => {
    const { profile } = props;
    // データ取得, ページ状態管理
    const { loading, offers, rfp } = useRfpClient();
    // ローディング表示
    if (loading && !rfp) {
        return _jsx(RfpClientOneQuestionViewSkeleton, {});
    }
    // リダイレクト: 案件詳細
    if (!rfp) {
        return _jsx(CustomRedirect, { to: myPagePath() });
    }
    return (_jsx(RfpClientOneQuestionPage, { offers: offers, profile: profile, rfp: rfp }));
};
